module.exports = __webpack_public_path__ + "static/media/facebook_white.061390a0.svg";